import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Header, HeaderRow, Navigation, Drawer, Content } from 'react-mdl';
import HomeIcon from '@material-ui/icons/Home';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';

const myTheme = createMuiTheme({
  typography: {
    allVariants: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      fontWeight: 550
    },
    h6: {
      fontSize: 20
    }
  }
});
function App({ page }) {
  return (
    <ThemeProvider theme={myTheme}>
      <Layout fixedHeader>
        <Header waterfall>
          <HeaderRow title="Kinh Thánh" />
          <HeaderRow>
            <Navigation>
              <a href="https://thuvientinlanh.org">
                <HomeIcon fontSize="large" />
              </a>
              <Link to="/kinh-thanh" key="kinhthanh">
                Kinh Thánh
              </Link>
              <Link to="/so-sanh-chuong" key="so-sanh-chuong">
                Song Ngữ
              </Link>
              <Link to="/so-sanh-cau" key="so-sanh-cau">
                So Sánh
              </Link>
              <Link to="/tim-kiem" key="tim-kiem">
                Tìm Kiếm
              </Link>
            </Navigation>
          </HeaderRow>
        </Header>
        <Drawer title="Menu">
          <Navigation>
            <a href="https://thuvientinlanh.org">
              <HomeIcon fontSize="large" />
            </a>
            <Link to="/kinh-thanh" key="kinhthanh">
              Kinh Thánh
            </Link>
            <Link to="/so-sanh-chuong" key="so-sanh-chuong">
              Song Ngữ
            </Link>
            <Link to="/so-sanh-cau" key="so-sanh-cau">
              So Sánh
            </Link>
            <Link to="/tim-kiem" key="tim-kiem">
              Tìm Kiếm
            </Link>
          </Navigation>
        </Drawer>
        <Content>
          <div className="page-content">
            {/* <KinhThanh /> */}
            {page}
          </div>
        </Content>
      </Layout>
    </ThemeProvider>
  );
}
// App.propTypes = {
//   children: PropTypes.element
// };
export default App;
